import EditSubmissionNew from './EditSubmissionNew';

export default EditSubmissionNew;
